import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Product from './Product';
import UILocale from '../../../../utils/UILocale';


const ProductAccessoriesTabs = ({
  accessoriesCategories, addProductToBundle, isMobile,
  disabledSegments
}) => {
  const [activeCategory, setActiveCategory] = useState(-1);

  return (
    <div className={'tabsEl tabsElAlt tsp'}>
      <ul className={'tabs noMobile'}>
        {
          accessoriesCategories.map((category, index) => (
            <li key={category.iSegmentId}>
              <a
                className={
                  `tabCtl${(index === activeCategory) || (index === 0 && activeCategory === -1)
                    ? ' active' : ''}`
                }
                href={`#category${index}`}
                onClick={(e) => {
                  e.preventDefault();

                  if (index !== activeCategory) {
                    setActiveCategory(index);
                  }
                }}
              >
                {category.name}
              </a>
            </li>
          ))
        }
      </ul>
      <div className={'tabContents'}>
        {
          accessoriesCategories.map((category, index) => (
            <div data-segment-id={category.iSegmentId} className={'tab'} key={category.iSegmentId}>
              <a
                href={`#category${index}`}
                className={`tabCtl mobile${index === activeCategory ? ' active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();

                  if (index !== activeCategory) {
                    setActiveCategory(index);
                  } else {
                    setActiveCategory(-1);
                  }
                }}
              >
                {category.name}
              </a>
              <div
                className={`tabContent${
                  (index === activeCategory) || (activeCategory === -1 && index === 0 && !isMobile)
                    ? ' tabShow' : ''
                }`}
                id={`#category${index}`}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: UILocale.getString('dynamic.bundles.bundle_builder_segment_maximum')
                      .replace('[#ITEMS_NUMBER#]', category.iLimit)
                  }}
                />
                <div className={'shopList'}>
                  {category.accessories.map((product, index) => (
                    <Product
                      {...product}
                      isMobile={isMobile}
                      onAddButtonClick={() => {
                        addProductToBundle(product.sProductId);
                      }}
                      key={`${product.sProductId}-${index}`}
                      addButtonDisabled={disabledSegments.includes(category.iSegmentId)}
                    />
                  ))}
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );


};

ProductAccessoriesTabs.propTypes = {
  accessoriesCategories: PropTypes.arrayOf(
    PropTypes.shape({
      iSegmentId: PropTypes.number.isRequired,
      iLimit: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      accessories: PropTypes.arrayOf(PropTypes.shape({
        sProductId: PropTypes.string,
        sLabel: PropTypes.string,
        sFullLabel: PropTypes.string,
        sImageUrl: PropTypes.string,
        sImageBigUrl: PropTypes.string,
        sComplementaryLabel: PropTypes.string,
        sDescription: PropTypes.string,
        fSeparatePrice: PropTypes.number,
        bIsAvailable: PropTypes.bool,
        bContainsSHD: PropTypes.bool,
        bIsSHD: PropTypes.bool,
        canBeHomeDelivered: PropTypes.bool,
        isFV: PropTypes.bool,
        canBeDownloaded: PropTypes.bool,
        canBeReservedandCollected: PropTypes.bool,
        canBePayedAndCollected: PropTypes.bool,
        isForwardOrderable: PropTypes.bool,
        isPreOrderable: PropTypes.bool,
        bIsDiscount: PropTypes.bool,
        sPrice: PropTypes.string,
        sSeparatePrice: PropTypes.string,
        sDiscount: PropTypes.string
      })).isRequired
    })
  ).isRequired,
  addProductToBundle: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  disabledSegments: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default ProductAccessoriesTabs;
